/**
 * useMobileDialogProps
 *
 * MUI cannot decide `fullScreen` from the theme (it is a prop, not a style), so dialogs that
 * should take over the screen on a phone have to ask at render time. Spread the result onto any
 * <Dialog>:
 *
 *   const dialogProps = useMobileDialogProps()
 *   <Dialog open={open} onClose={onClose} {...dialogProps} />
 *
 * Kept deliberately small so every dialog in the portal agrees on the same breakpoint.
 */

import { useMediaQuery, useTheme } from '@mui/material'

export interface MobileDialogProps {
  /** True below the `sm` breakpoint (600px), where a centred dialog is unusable. */
  fullScreen: boolean
}

export function useMobileDialogProps(): MobileDialogProps {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return { fullScreen }
}
